export interface TenantConfig {
  name?: string;
  logo_url?: string;
  primary_color?: string | null;
  secondary_color?: string | null;
  site_url?: string;
  tenant_id?: string;
  account?: { suspended: boolean; contact_email: string | null };
}

let pending: Promise<TenantConfig> | null = null;

// Branding and plan state of the tenant, fetched once per page load and
// shared by the boot code and the router guard.
export function loadTenantConfig(): Promise<TenantConfig> {
  if (!pending) {
    pending = fetch("/v1/tenant/config")
      .then((r) => r.json())
      .then((config: TenantConfig) => {
        (window as any).__TENANT_CONFIG = config;
        return config;
      })
      .catch(() => ({}));
  }
  return pending;
}
